export type FieldTestIdKind = "select" | "input" | "textarea";

const slugifyFieldName = (name: string) => name.replace(/[.[\]]+/g, "-").replace(/-+$/g, "");

export const FIELD_TEST_ID_OVERRIDES: Record<string, string> = {
  shipment_title: "form-field-quick_request_title",
};

export const stopTestId = (prefix: string, index: number) => `${prefix}-${index}`;

export const testIdFromFieldName = (name: string, kind: FieldTestIdKind) => {
  const override = FIELD_TEST_ID_OVERRIDES[name];
  if (override) return override;

  const slug = slugifyFieldName(name);
  switch (kind) {
    case "select":
      return `search-select-${slug}`;
    case "textarea":
      return `textarea-${slug}`;
    case "input":
    default:
      return `form-field-${slug}`;
  }
};

export const serviceRequirementRadioTestId = (requirementIndex: number, value: "true" | "false") =>
  `request-form-service-requirement-${requirementIndex}-radio-${value === "true" ? "yes" : "no"}`;
